import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'asm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem('r-officer-monthly-plans', {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      search: filter.search,
      schedule: filter.schedule,
      officer: filter.officer
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem('r-officer-monthly-plans')
}

export {
  setTableOptions,
  getTableOptions
}
